import React, { useState } from 'react';
import CommonModal from '../../../Components/CommonModal';
import CommonLoader from '../../../Components/CommonLoader';
import { risk_portal_role_create } from '../../../services';

// Risk Registry roles — shared by the invite form (role picker) and the User
// Management table (inline role dropdown). Mirrors the reference RiskPortal.js
// role list exactly.
export const ROLE_OPTIONS = [
    { value: 'risk_admin', label: 'Risk Admin' },
    { value: 'risk_manager', label: 'Risk Manager' },
    { value: 'risk_owner', label: 'Risk Owner' },
    // { value: 'risk_reviewer', label: 'Risk Reviewer' },
    // { value: 'business_owner', label: 'Business Owner' },
    // { value: 'risk_committee', label: 'Risk Committee' },
    // { value: 'ciso', label: 'CISO (Read-Only)' },
];

// InviteUser — CommonModal (config-driven fields) that creates a Risk Registry
// role invite via risk_portal_role_create (writes the audit log + emails the
// invite, same path the reference portal uses). The page owns the toast; this
// form reports back via onSuccess / onError.
export default function InviteUser({ show, onClose, onSuccess, onError }) {
    const [busy, setBusy] = useState(false);

    const submit = async (data) => {
        setBusy(true);
        try {
            await risk_portal_role_create({
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                role: data.role,
                status: 'invited',
            });
            onSuccess?.(`Invite sent to ${data.email}`);
            onClose?.();
        } catch (e) {
            onError?.(e?.response?.data?.error?.message || e?.response?.data?.response_data?.message || 'Invite failed');
        } finally {
            setBusy(false);
        }
    };

    return (
        <CommonModal
            show={show}
            onHide={onClose}
            mid
            title="Invite User"
            subtitle="Send a Risk Registry invitation — the user gets an email to set their password."
            fields={[
                { name: 'first_name', label: 'First Name', type: 'text', half: true, required: 'First name is required.' },
                { name: 'last_name', label: 'Last Name', type: 'text', half: true },
                { name: 'email', label: 'Email', type: 'text', required: 'Email is required.', pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Enter a valid email address.' } },
                { name: 'role', label: 'Role', type: 'select', options: ROLE_OPTIONS },
            ]}
            defaultValues={{ first_name: '', last_name: '', email: '', role: 'risk_owner' }}
            onSubmit={submit}
            buttons={[
                { text: 'Cancel', variant: 'secondary', onClick: onClose },
                { text: 'Send Invite', variant: 'primary', type: 'submit' },
            ]}
        >
            {busy && <CommonLoader overlay label="Sending invite…" />}
        </CommonModal>
    );
}
